// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"2d54b21a","146":"030433ee","179":"ab49afc6","206":"407e65f5","232":"7967a00a","366":"e2284b7c","453":"b6dabc91","589":"e9293e85","626":"5895f73e","739":"7443165e","780":"e93e6e77","884":"7b3f960b"}[chunkId] + ".chunk.js";
};